<div class="card">
  <div class="card-header"><h5 class="h4 mb-0 d-inline">Today's Workouts</h5>
    <a *ngIf="!isCoachView" (click)="addManualWorkout()" href="javascript:void(0)" class="text-nowrap float-right small-link"> Add Workout </a>
  </div>
  <div *ngIf="todaysWorkouts == null" class="container mt-3 mb-2 text-center">No events today</div>
  <calendar-day-details *ngIf="todaysWorkouts" [day]="todaysWorkouts"  (actionTaken)="onTodaysWorkoutsChanged($event)"></calendar-day-details>
  <div *ngIf="!isCoachView" class="container mb-2 text-center"><a href="javascript:void(0)" [routerLink]="['/runner/calendar']" class="text-nowrap small-link"> View Workout Calendar </a></div>
</div>
